<template>
  <div>
    <div class="container-fluid right_wrapper">
      <CampaignGroupHeader
        @showEditCampaign="showEditCampaign"
      ></CampaignGroupHeader>
      <div
        v-if="showLoader"
        class="spinner-border"
        style="margin: auto; display: block; margin-top: 60px"
      ></div>
      <div v-else>
        <CampaignGroupListGrid
          class="table_wrap"
          @showEditCampaign="showEditCampaign"
        ></CampaignGroupListGrid>
        <div class="dropup" v-if="campaignGroupSelectedList && campaignGroupSelectedList.length">
          <div
            class="bulk_action dropdown-toggle"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span class="text">Bulk Actions</span>
            <!-- <div style="padding-left:10px;float:left"><i class="fas fa-caret-up"></i></div> -->
            <CampaignGroupActions />
          </div>
        </div>

        <CampaignGroupGridFooter
          v-if="campaignGroupList.length != 0"
          class="main_footer_wrap"
        ></CampaignGroupGridFooter>
      </div>
    </div>

    <AddCampaignGroupModal
      @saveNewCampaignGroup="saveNewCampaignGroup"
    ></AddCampaignGroupModal>

    <EditCampaignGroupModal
      v-if="campaignId"
      :campaignId="campaignId"
      calledFrom="campaignGroup"
    ></EditCampaignGroupModal>
  </div>
</template>

<script>
import CampaignGroupHeader from "@/components/campaign-group/CampaignGroupHeader1";
import CampaignGroupListGrid from "@/components/campaign-group/CampaignGroupListGrid";
import CampaignGroupGridFooter from "@/components/campaign-group/CampaignGroupGridFooter";
import AddCampaignGroupModal from "@/components/campaign-group/AddCampaignGroupModal";
import EditCampaignGroupModal from "@/components/campaign-group/EditCampaignGroupModal";
import CampaignGroupActions from "@/components/campaign-group/CampaignGroupActions1";

export default {
  name: "CampaignGroup",
  data() {
    return {
      campaignId: "",
      modalShow: false,
    };
  },

  components: {
    CampaignGroupHeader,
    CampaignGroupListGrid,
    CampaignGroupGridFooter,
    AddCampaignGroupModal,
    EditCampaignGroupModal,
    CampaignGroupActions,
  },
  mounted() {
    this.$store.dispatch("callAnalytics", {
      data: window.location.href,
      this: this,
      type: "campaignGroupList",
    });
    this.$store.dispatch("getAllVendor");
    this.$store.dispatch("profileBrandList");
    this.getCampaignGroupList();
  },
  watch: {
    sort() {
      this.getCampaignGroupList();
    },
  },
  computed: {
    sort: {
      set(val) {
        this.$store.commit("setSelectedSortOrder", val);
        this.getCampaignGroupList();
      },
      get() {
        return this.$store.state.selectedSortOrder;
      },
    },
   campaignGroupSelectedList:{
     get(){
       return this.$store.state.campaign.campaignGroupSelectedList;
     }
   },
    campaignGroupList: {
      set(val) {
        this.$store.state.campaign.campaignGroupList = val;
      },
      get() {
        return this.$store.state.campaign.campaignGroupList;
      },
    },
    showLoader: {
      get() {
        return this.$store.getters["getShowLoader"];
      },
    },
  },
  methods: {
    getCampaignGroupList() {
      if (this.$store.state.calledFromCancel) {
        this.$store.state.calledFromCancel = false;
      } else {
        this.$store.dispatch("campaign/getCampaignGroupList", {
          callback: (res) => {},
        });
      }
    },
    saveNewCampaignGroup(Item) {
      let vm = this;
      this.$store.commit("showLoadingSpinner", null, { root: true });
      this.$store
        .dispatch("campaign/addAndUpdateCampaignGroup", Item)
        .then((res) => {
          console.log("Called1");
          vm.$store.dispatch("campaign/getCampaignGroupList").then((res) => {
            console.log("Called2");
          });
        });
    },
    showEditCampaign(itemId) {
      this.campaignId = itemId;
      const vm = this;

      this.$nextTick(() => {
        window.$("#editCampaign").modal({
          show: true,
        });
        window.$("#editCampaign").on("hide.bs.modal", function (e) {
          e.stopImmediatePropagation();
          vm.campaignId = "";
        });
      });
    },
  },
};
</script>
<style lang="scss">
</style>
